<template>
  <b-modal
    modal-class="audit-trail"
    dialog-class="audit-trail"
    v-model="ShowAuditTrail"
    :no-close-on-backdrop="true"
    size="xl"
  >
    <template v-slot:modal-header="{ close }">
      <h5 class="modal-title">{{ ModalTitle }}</h5>
      <button class="close" @click="Cancel()"></button>
    </template>

    <div class="profile-component">
      <vue-html2pdf
        :show-layout="true"
        :float-layout="false"
        :enable-download="false"
        :preview-modal="false"
        :paginate-elements-by-height="1800"
        :filename="PDFFileName"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="100%"
        @beforeDownload="beforeDownload($event)"
        ref="html2Pdf"
      >
<section slot="pdf-content">
<div class="request-status-container">
            <div v-if="IsHistoryAvailable" class="audit-label">Most Recent Audit Trail</div>
            <ul class="steps request-status">
              <li
                class="step"
                v-for="(status, index) in statusList"
                :key="status.Name"
                style="display: inline"
              >
                <div class="step-content">
                  <span class="step-circle">&nbsp;</span>
                  <span class="step-text">
                    <div class="status">
                      {{ FormatTask(status.TaskName, status.TaskState) }}
                    </div>
                    <div class="date">{{ FormatDate(status.UpdatedDate) }}</div>
                    <div class="updatedby">
                      {{
                        GetStatus(
                          status.TaskState,
                          status.UpdatedBy,
                          index,
                          status.TaskName
                        )
                      }}
                    </div>
                    <a
                      class="comments"
                      v-if="status.Comments"
                      :title="status.Comments"
                      v-b-tooltip.hover
                    >
                      View Comments
                    </a>
                  </span>
                </div>
              </li>
            </ul>
            <div v-if="IsHistoryAvailable && ShowHistoryStates" class="audit-label">Previous Audit Trail</div>
            <a class="btn btn-link" v-if="IsHistoryAvailable && !ShowHistoryStates" @click="GetProfileAuditWorkflowHistoryStates">
              <b-img :src="collapseIcon"></b-img> SEE PREVIOUS AUDIT TRAILS</a>
            <span v-if="ShowHistoryStates && IsHistoryAvailable">
            <ul v-for="(historyStatusList,parentIndex) in HistoryAuditTrail" :key="historyStatusList.ProcessID" class="steps request-status">
              <li
                class="step"
                v-for="(status, index) in historyStatusList.States"
                :key="status.Name"
                style="display: inline"
              >
                <div class="step-content">
                  <span class="step-circle">&nbsp;</span>
                  <span class="step-text">
                    <div class="status">
                      {{ FormatTask(status.TaskName, status.TaskState) }}
                    </div>
                    <div class="date">{{ FormatDate(status.UpdatedDate) }}</div>
                    <div class="updatedby">
                      {{
                        GetStatus(
                          status.TaskState,
                          status.UpdatedBy,
                          index,
                          status.TaskName,
                          parentIndex
                        )
                      }}
                    </div>
                    <a
                      class="comments"
                      v-if="status.Comments"
                      :title="status.Comments"
                      v-b-tooltip.hover
                    >
                      View Comments
                    </a>
                  </span>
                </div>
              </li>
            </ul>
            </span>
             <a class="btn btn-link" v-if="IsHistoryAvailable && ShowHistoryStates" @click="HideHistoryWorkflow"><b-img :src="expandIcon"></b-img> See less</a>
          </div>
     <div class="row" >
      <b-card class="col-lg-12 main-content">
        <div class="panel-list">
          <div class="panel-body">
            <profile-unlock-overview :ProfileUnlockRequestDetail = ProfileUnlockRequestDetail></profile-unlock-overview>
            <profile-unlock-instruction :ProfileUnlockRequestDetail = ProfileUnlockRequestDetail></profile-unlock-instruction>
            <b-row class="panel-title" v-if="ProfileUnlockRequestDetail.Company">
              <label class="col-lg-6 Intercompany-Agency"
                >REQUESTOR INFO</label
              >
            </b-row>
            <b-row class="panel-content" v-if="ProfileUnlockRequestDetail.Company">
              <b-col cols="lg-4">
                <label>COMPANY</label>
                <p>{{ProfileUnlockRequestDetail.Company}}</p>
              </b-col>
                <b-col cols="lg-4">
                <label>DEPARTMENT</label>
                <p>{{ProfileUnlockRequestDetail.Department}}</p>
              </b-col>
                <b-col cols="lg-4">
                <label>TITLE</label>
                <p>{{ProfileUnlockRequestDetail.Title}}</p>
              </b-col>
                <b-col cols="lg-4">
                <label>TELEPHONE</label>
                <p>{{ProfileUnlockRequestDetail.Telephone}}</p>
              </b-col>
              <b-col cols="lg-4">
                <label>COUNTRY</label>
                <p>{{ProfileUnlockRequestDetail.ADCountry}}</p>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-card>
      </div>
      </section>
      </vue-html2pdf>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <div class="text-right footer-buttons">
        <button class="btn custom-button btn-primary" @click="DownloadAsPDF()">
          Download As PDF
        </button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import moment from "moment";
import VueHtml2pdf from "vue-html2pdf";
import ProfileUnlockOverview from "@/components/Profile/Overview";
import ProfileUnlockInstruction from "@/components/Profile/Instruction";

export default {
  components: {
    VueHtml2pdf,
    "profile-unlock-overview": ProfileUnlockOverview,
    "profile-unlock-instruction": ProfileUnlockInstruction
  },
  name: "AuditTrail",
  props: {
    id: {
      required: true,
      type: Number,
    },
    closeAuditModal: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      ProfileUnlockRequestDetail:{},
      collapseIcon: require("@/assets/Icons/arrow-down.svg"),
      expandIcon: require("@/assets/Icons/arrow-up-big.svg"),
      ShowAuditTrail: true,
      statusList: [],
      HistoryAuditTrail: [],
      HistoryLoaded:false,
      ShowHistoryStates:false,
      HistoryProcessCount:0
    };
  },
  created() {
    this.ShowAuditTrail = true;
    this.GetWorkflowStates();
    this.GetICRequestWithTaskDetails();
  },
  computed: {
    IsHistoryAvailable(){
   return this.HistoryProcessCount>0;
    },
    ModalTitle() {
      return this.ProfileUnlockRequestDetail != null
        ? `Audit Trail - ${this.ProfileUnlockRequestDetail.Agency}`
        : "Audit Trail";
    },
    PDFFileName() {
      return `${this.ModalTitle}_${moment(new Date()).format(
        "MMDDYYYYHHmmss"
      )}`;
    },
  },
  methods: {
    async downloadItem(file) {
      this.$store
        .dispatch("client/DownloadICFile", file)
        .then((response) => {
          const blob = new Blob([response.data], { type: file.Extension });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = file.Name;
          link.click();
          URL.revokeObjectURL(link.href);
        })
        .catch((ex) => {
          if (ex.response) {
            this.$store.dispatch(
              "progress/setErrorMessage",
              `Error while downloading file. ${ex.response.data}`
            );
          } else {
            this.$store.dispatch(
              "progress/setErrorMessage",
              `Error while downloading file. ${ex}`
            );
          }
        });
    },

   async GetICRequestWithTaskDetails(){
     var inputObj = {
                id: parseInt(this.id),
                isedit: false,
            };
      this.$store
        .dispatch(
          "client/GetProfileUnlockRequestWithTaskDetails",
          inputObj
        )
        .then((res) => {
          this.ProfileUnlockRequestDetail = res.data;
        })
        .catch((err) => {
          this.Error = true;
          alert(err);
        });
    },

    async GetWorkflowStates(){
     this.$store
      .dispatch("client/GetProfileAuditFormData", parseInt(this.id))
      .then((res) => {
        this.statusList = res.data.States;
        this.HistoryProcessCount=res.data.HistoryProcessCount;
      })
      .catch((err) => {
        alert(err);
      });
    },

  async GetProfileAuditWorkflowHistoryStates() {
      if(this.HistoryLoaded!=true){
      this.$store
        .dispatch("client/GetProfileWorkflowHistoryStates", parseInt(this.id))
        .then((res) => {
          this.HistoryAuditTrail = res.data;
          this.HistoryLoaded=true;
          this.ShowHistoryStates=true;
        })
        .catch((err) => {
          alert(err);
        });
      }
      if(this.HistoryLoaded==true){
        this.ShowHistoryStates=true;
      }
    },

    HideHistoryWorkflow(){
      this.ShowHistoryStates=false;
    },

    async beforeDownload({ html2pdf, options, pdfContent }) {
      await html2pdf()
        .set(options)
        .set({
          pagebreak: { mode: ["avoid-all","css","legacy"] },
        })
        .from(pdfContent)
        .toPdf().save();
    },
    FormatTask(name,state){
      if(name=="Unlock Request")
      {
          name="Financial Systems Unlock Complete";
      }
      else if (name=="Relock Request")
      {
          name="Financial Systems Relock Complete";
      }
      if(state=='Finished'){
         return `${name}`;
      }else{
        return name;
      }
    },
    FormatDate(date) {
      return date != null && moment(new Date(date)).isValid()
        ? moment(date).local(true).format("MM/DD/YYYY hh:mm A")
        : "-";
    },
    GetStatus(taskStatus, updatedBy, index, taskName,parentIndex) {
      let status = "";
      const completedTaskNames = ["Media Finance Approval", "MR Approval", "Level2 Approval"];
      const readyTaskNames = ["Relock Request", "Unlock Request", "Level2 Approval"];
      let lastItem = this.statusList.length - 1 == index;
      if(parentIndex!=undefined && parentIndex!=null && parseInt(parentIndex)>-1){
        lastItem = this.HistoryAuditTrail[parentIndex].States.length - 1 == index;
      }
      let firstItem = index == 0;

      switch (taskStatus) {
        case "Finished":
          status = firstItem ?
           `Submitted by ${updatedBy}` : lastItem  ?
           `Completed by ${updatedBy}`: completedTaskNames.includes(taskName) ?
           `Approved by ${updatedBy}` : `Completed by ${updatedBy}`;
          break;
        case "Ready":
          status =
            readyTaskNames.includes(taskName) ? "Pending for completion" : `Waiting for approval`;
          break;
        case "Assigned":
          status = `Waiting for approval`;
          break;
        case "Started":
          status = ``;
          break;
        case "Canceled":
          status = lastItem
            ? `Rejected by ${updatedBy}`
            : firstItem
            ? `Submitted by ${updatedBy}`
            : `Approved by ${updatedBy}`;
          break;
        default:
          status = ``;
          break;
      }
      return status;
    },

    Cancel() {
      this.ShowAuditTrail = false;
      this.$emit("closeAudit");
    },
    DownloadAsPDF() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
};
</script>

<style scoped>
@media screen and (min-width: 1200px) {
  .profile-component {
    padding: 1rem 3rem 0px !important;
  }
}
.approval-side-section {
    background-color: rgba(162, 169, 173, 0.05);
    margin-bottom: 2px;
    padding-right: 35px !important;
    -webkit-box-shadow: 0 1px 3px 0 rgb(9 30 66 / 12%);
    box-shadow: 0 1px 3px 0 rgb(9 30 66 / 12%);
    border: solid 1px rgba(239, 242, 244, 0.2);
    border-left: none;
    border-radius: 0px 8px 8px 0px;
}

.Intercompany-Agency{
    font-size: 14px;
    font-family:"Open Sans";
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #4d5161 !important;
    text-transform:none;
}


.panel-list:not(.media-dropdowns) {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}
.panel-list .panel-body .panel-title {
  border-bottom: 1px solid rgba(151, 151, 151, 0.2);
  width: 100%;
  margin-left: 0px;
  margin-bottom: 25px !important;
}
.panel-list .panel-body .panel-title label {
  color: #77a2bb;
  margin-bottom: 0px !important;
  padding-top: 13px !important;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.57;
  letter-spacing: normal;
  padding-left: 0px !important;
  min-height: 35px;
}
.panel-list .panel-body .panel-title .btn {
  padding-left: 5px;
  padding-right: 5px;
}
.panel-list .panel-body .panel-title > div {
  padding-right: 0px !important;
  float: right;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.75;
  letter-spacing: normal;
  color: #00a1d2;
}
.panel-list .panel-content label {
  text-transform: uppercase;
  color: #2c3865;
  font-size: 12px;
  margin-bottom: 1px !important;
  padding-left: 0px;
}
.panel-list .panel-content p {
  text-transform: uppercase;
  color: #4d5161;
  font-size: 14px;
  font-weight:600;
}
.panel-content.row > div > label:first-child {
  color: #a2a9ad !important;
  font-family: "Open Sans" !important;
  font-size: 10px;
  font-weight: 600 !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.42;
  letter-spacing: normal;
}
.panel-content.row > div > *:not(:first-child) {
  font-family: "Open Sans" !important;
  font-size: 14px !important;
}
.panel-content.row > div > div {
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4d5161;
}
.panel-list > .panel-body {
  margin-top: 1rem !important;
}
.panel-content.row > div {
  margin-bottom: 10px !important;
}
.request-status {
  background-color: rgba(216, 216, 216, 0.2);
  margin-left: 1rem;
  margin-right: 1rem;
  display: flex;
  height: 135px;
  border-radius: 5px;
}
.request-status .status {
  font-size: 12px;
  font-family: "Open Sans";
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4d5161;
}
.request-status .date {
  font-size: 10px;
  font-family: "Open Sans";
  font-weight: regular;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #a2a9ad;
}
.request-status .updatedby {
  font-size: 10px;
  font-family: "Open Sans";
  font-weight: regular;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #4d5161;
  padding-right: 5px;
}
.audit-label {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4d5161;
  margin-left: 2rem;
  padding-top:1rem;
}
.panel-content.row > div > :not(:first-child) {
  font-family: "Open Sans" !important;
  font-size: 14px !important;
}
.request-status {
  background-color:transparent;
  margin-left: 0rem;
  margin-right: 0rem;
  display: flex;
  height: auto;
  border-radius: 5px;
  padding-left: 2rem;
}
.request-status-container {
  background-color: rgba(216, 216, 216, 0.2);
  margin-left:3rem;
  margin-right:3rem;

}
.request-status .comments {
  font-size: 12px;
  font-family: "Open Sans";
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: #00a1d2;
}
.steps.request-status {
  padding-top: 20px;
  padding-bottom:15px;
}
.steps.request-status .step-text > * {
  white-space: normal;
  word-break: break-word;
}
.steps.request-status .step-content {
  min-width: 11rem !important;
  max-width: 11rem !important;
  padding-right: 0px !important;
}
</style>